<script setup lang="ts">
import { usePersonalInformationStore } from '../../stores/personalInformationStore';

const personalInformationStore = usePersonalInformationStore();

defineProps<{
  title: string;
  name: string;
}>();

defineEmits<{
  'navigate-home': [];
}>();


</script>

<template>
  <div class="flex flex-col pt-7 pb-2 " >
    <div class="flex flex-col justify-start items-start py-1 w-fit hover-opacity " >
    <div class="flex justify-start items-end py-1 w-fit " >
      <div class="flex items-end justify-end">
        <img src="@/assets/mit-logo.svg" alt="image" class="w-[67px] h-[35px] cursor-pointer"
          @click="$emit('navigate-home')" />
      </div>
      <div
        class="ml-1 text-xl font-semibold leading-none tracking-normal text-black flex items-end justify-start cursor-pointer"
        @click="$emit('navigate-home')">
        {{ $props.title }}
      </div>
    </div>
    <div v-if="personalInformationStore.profile != null"
      class=" text-sm leading-none tracking-normal text-black flex items-end justify-start ">
      {{ 'Welcome ' + personalInformationStore.profile?.firstName  + ' ' + personalInformationStore.profile?.lastName   }}
    </div>
    <div v-else class=" text-sm leading-none tracking-normal text-black flex items-end justify-start ">
      <div class="d h-3 w-50"></div>
    </div>
    </div>
  </div>
</template>

<style scoped>
.hover-opacity {
  opacity: 1;
  transition: opacity 0.3s ease;
}

.hover-opacity:hover {
  opacity: 0.5;
}
</style>